module.exports = __webpack_public_path__ + "img/poker-c01.ff2327ac.svg";